<div class="flex items-center justify-center py-3">
    <button
        type="button"
        class="border-neutral-variant-40/20 hover:bg-primary/10 flex size-9.5 items-center justify-center rounded-l-lg border bg-white pb-0.5 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white"
        [disabled]="!hasPrevious()"
        [class.text-gray-400]="!hasPrevious()"
        (click)="onPreviousClick()"
    >
        <svg-icon src="assets/icons/Chevron-Left.svg" class="h-4" [svgStyle]="{ width: '20px', height: '20px' }" />
    </button>

    @if (showFirstPage()) {
        <button
            type="button"
            class="border-neutral-variant-40/20 hover:bg-primary/10 flex size-9.5 items-center justify-center border bg-white pb-0.5 text-sm font-medium"
            (click)="onPageClick(1)"
        >
            1
        </button>
        @if (showStartEllipsis()) {
            <span
                class="border-neutral-variant-40/20 flex size-9.5 items-center justify-center border-t border-r border-b text-sm font-medium"
            >
                ...
            </span>
        }
    }

    @for (page of pages(); track page) {
        <button
            type="button"
            class="border-neutral-variant-40/20 flex size-9.5 items-center justify-center border-t border-r border-b text-sm font-medium"
            [class]="
                page === currentPage()
                    ? 'text-primary bg-primary/20 border-primary border-l'
                    : 'border-neutral-variant-40/20 hover:bg-primary/10'
            "
            (click)="onPageClick(page)"
        >
            {{ page }}
        </button>
    }

    @if (showLastPage()) {
        @if (showEndEllipsis()) {
            <span
                class="border-neutral-variant-40/20 flex size-9.5 items-center justify-center border-t border-r border-b text-sm font-medium"
            >
                ...
            </span>
        }
        <button
            type="button"
            class="border-neutral-variant-40/20 hover:bg-primary/10 flex size-9.5 items-center justify-center border-t border-r border-b bg-white pb-0.5 text-sm font-medium"
            (click)="onPageClick(totalPages())"
        >
            {{ totalPages() }}
        </button>
    }

    <button
        type="button"
        class="border-neutral-variant-40/20 hover:bg-primary/10 flex size-9.5 items-center justify-center rounded-r-lg border-t border-r border-b bg-white pb-0.5 text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white"
        [disabled]="!hasNext()"
        [class.text-gray-400]="!hasNext()"
        (click)="onNextClick()"
    >
        <svg-icon src="assets/icons/Chevron-Right.svg" class="h-4" [svgStyle]="{ width: '20px', height: '20px' }" />
    </button>
</div>
